import { lazy } from 'react';
import { useMfOrganizationSettingsConfig } from './useMfOrganizationSettingsConfig';

const Mfe = lazy(() => import('mfOrganizationSettings/OrganizationSettings'));

function OrganizationSettings() {
  const config = useMfOrganizationSettingsConfig();

  return (
    <div
      style={{ display: 'contents' }}
      data-testid="adm.organizationSettings.wrapper"
    >
      <Mfe {...config} />
    </div>
  );
}

export default OrganizationSettings;
